var $ = require('jquery');
var Marionette = require('marionette');

var Layout = Marionette.View.extend({
    events: {
        'click @ui.cancel,@ui.close': 'cancel',
        'click @ui.save': 'save'
    },
    regions: {
        body: '#body'
    },
    ui: {
        cancel: '#cancel',
        close: '#close',
        dialog: '#dialog',
        save: '#save',
        modalDialog: "#modalDialog",
        body:'#body'
    },
    template: '#dialogLayout',
    initialize: function () {
        this.listenTo(this.options.view, 'close:dialog', this.cancel);
    },
    onRender: function () {
        var context = this;
        this.ui.dialog.modal('show');
        if (!this.ui.cancel.html()) {
            this.ui.cancel.addClass('hidden');
        }
        if (!this.ui.save.html()) {
            this.ui.save.addClass('hidden');
        }
        this.ui.modalDialog.addClass(this.options.size);
        this.ui.body.addClass(this.options.modalBodyClass);
        // Disable the save button if disableSave is true.
        if (this.options.allowDisableSave) {
            var disableSave = this.options.validate.get('disableSave');
            this.ui.save.attr('disabled', !!disableSave);
            // Enable/Disable the save button based on the change in disableSave attribute.
            this.options.validate.on('change:disableSave', function (value) {
                    context.ui.save.attr('disabled', value.get('disableSave'));
                }
            );
        }
    },
    cancel: function () {
        if (!this.options.validateOnCancel || this.options.validate.isValid(true)) {
            this.ui.dialog.modal('hide');
            this.options.deferred.reject();
            this.options.allowDisableSave && this.options.validate.off('change:disableSave');
            this.destroy();
        }
    },
    save: function () {
        if (!this.options.validate || this.options.validate.isValid(true)) {
            this.ui.dialog.modal('hide');
            this.options.deferred.resolve();
            this.destroy();
        }
    }
});

// Expects a view to render in the dialog body. Optionally provide labels and a backbone model if it needs to be validated before resolving the promise.
module.exports.show = function (options) {
    var cancel = options.cancelLabel;
    var size = options.size || "modal-md";
    var header = options.headerLabel || '{Header}';
    var save = options.saveLabel;
    var validate = options.validate;
    var allowDisableSave = options.allowDisableSave;
    var validateOnCancel = options.validateOnCancel;
    var view = options.view;
    var modalBodyClass = options.modalBodyClass;
    var consultation = require('Consultation');
    var deferred = $.Deferred();
    var layout = new Layout({
        deferred: deferred,
        model: new Backbone.Model({
            cancel: cancel,
            header: header,
            save: save
        }),
        validate: validate,
        size: size,
        view: view,
        validateOnCancel: validateOnCancel,
        modalBodyClass: modalBodyClass,
        allowDisableSave: allowDisableSave,
    });

    consultation.show({regionName: 'modal', view: layout});
    layout.getRegion('body').show(view);
    return deferred.promise();
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/Dialog.js